import React from 'react'
import { Grid, Typography, Paper, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { printValue } from '../utils/PrintValue'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    color: 'rgba(0,0,0,0.9)',
    height: '100%'
  },
  descript: { fontSize: '0.8rem', color: '#545454' },
  descriptVal: { fontSize: '0.85rem' },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(4)
  }
}))

export default function VendorAgreementMain(props) {
  const classes = useStyles()
  const { data, isLoading } = props

  const renderValue = (lookup, description, options = {}, secondary = null, secondType = null) => {
    return printValue(data, lookup, description, secondary, secondType, {
      ...options,
      classes: {
        description: classes.descript,
        value: classes.descriptVal
      }
    })
  }

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    )
  }

  // Check if data is empty or undefined
  const hasData = data && Object.keys(data).length > 0

  if (!hasData) {
    return (
      <div className={classes.loadingContainer}>
        <Typography variant="subtitle1">No data available</Typography>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <Grid
        container
        spacing={1}
        direction='row'
        justifyContent='flex-start'
        alignItems='stretch'
      >
        {/* Header Section - Left Column */}
        <Grid item xs={12} sm={12} md={8} lg={8}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Header</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6}>
                {renderValue('VENDOR', 'Vendor')}
                {renderValue('DESCRIPTION', 'Description')}
                {renderValue('DOC_ORIGIN_IND', 'Origin')}
                {renderValue('EFFECTIVE_DT', 'Effective Date', {type: 'date'})}
                {renderValue('EXPIRE_DT', 'Expiration Date', {type: 'date'})}
                {renderValue('REVIEW_DATE', 'Review Date', {type: 'date'})}
                {renderValue('AGRMT_ADMIN', 'Agreement Admin')}
                {renderValue('CURRENCY_CODE', 'Currency Code')}
                {renderValue('ORDER_MIN_AMT', 'Per Order Min Amount', {type: 'currency'})}
                {renderValue('ORDER_MAX_AMT', 'Per Order Max Amount', {type: 'currency'})}
                {renderValue('AGRMT_MAX_AMT', 'Lifetime Max Amount', {type: 'currency'})}
                {renderValue('LIFETIME_EDIT', 'Lifetime Max Edit')}
                {renderValue('DS_AGRMT_REF', 'Dual Source Agreement')}
                {renderValue('BRK_LEVEL_FL', 'Line Level Breaks on')}
                {renderValue('MATCH_UOM_FL', 'UOMs Must Match')}
                {renderValue('OVERID_UOM_FL', 'Use Agreement UOM')}
              </Grid>
            {/* </Grid>
          </Paper>
        </Grid>

        {/* Middle Column 
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Paper elevation={3} className={classes.paper}>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            > */}
              <Grid item xs={12} sm={6}>
                {renderValue('PURCH_FR_LOC', 'Purchase From')}
                {renderValue('AGRMT_MAX_PCT', 'Notification Percent')}
                {renderValue('PCT_REMAINING', 'Percent Remaining')}
                {renderValue('PCT_ORDERED', 'Percent Ordered')}
                {renderValue('AMT_REMAINING', 'Amt Remaining', {type: 'currency'})}
                {renderValue('AMT_ORDERED', 'Amt Ordered', {type: 'currency'})}
                {renderValue('ALLW_UNDEF_ITM', 'Non agreement items not on agreement')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Defaults Section - Right Column */}
        <Grid item xs={12} sm={12} md={4} lg={4}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Defaults</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12}>
                {renderValue('MANUF_CODE', 'Manufacturer Code')}
                {renderValue('MANUF_DIVISION', 'Manufacturer Division')}
                {renderValue('DFLT_ACCT_UNIT', 'Accounting Unit')}
                {renderValue('DFLT_DIST_CO', 'Distribution Company')}
                {renderValue('DFLT_ACCOUNT', 'Account')}
                {renderValue('DFLT_SUB_ACCT', 'Sub Account')}
                {renderValue('DFLT_ACTIVITY', 'Activity')}
                {renderValue('DFLT_ACCT_CAT', 'Account Category')}
                {renderValue('DFLT_TAXBL_FL', 'Taxable')}
                {renderValue('TAX_CODE', 'Tax Code')}
                {renderValue('ITEM_CREATE_FL', 'Item Create')}
                {renderValue('ITEM_ASGN_FLD', 'Item Assign Field')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Type Specifics */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Type Specifics</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6}>
                {renderValue('GRP_PURCH_ORG', 'Group Purchasing Organization')}
                {renderValue('STOCKLESS_FL', 'Stockless Flag')}
                {renderValue('REBATE', 'Rebate')}
                {renderValue('BUYER', 'Buyer')}
                {renderValue('PO_NUMBER', 'PO Number')}
                {renderValue('LAST_PO_REL', 'Last PO Release')}
                {renderValue('PO_CODE', 'PO Code')}
                {renderValue('SCH_FREQUENCY', 'Schedule Frequency')}
                {renderValue('SCH_NO_OF_REL', 'Maximum Release Number')}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderValue('ISSUE_FLAG', 'Issue Flag')}
                {renderValue('LAST_REL_DATE', 'Last PO Delivery Date', {type: 'date'})}
                {renderValue('PRIORITY', 'Priority')}
                {renderValue('REBATE_PERCENT', 'Rebate Percent')}
                {renderValue('TERM_CODE', 'Payment Terms')}
                {renderValue('FOB_CODE', 'Ship Terms')}
                {renderValue('FREIGHT_TERMS', 'Freight Terms')}
                {renderValue('PO_USER_FLD_1', 'User Field 1')}
                {renderValue('PO_USER_FLD_3', 'User Field 2')}
                {renderValue('PO_USER_FLD_5', 'User Field 3')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Commitments */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Commitments</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6}>
                {renderValue('AC_COMMIT_FLAG', 'Create AC Commitments')}
                {renderValue('GL_COMMIT_FLAG', 'Create GL Commitments')}
                {renderValue('COM_COMPANY', 'Commitment Company')}
                {renderValue('COM_ACCT_UNIT', 'Accounting Unit')}
                {renderValue('COM_ACCOUNT', 'Account')}
                {renderValue('COM_SUB_ACCT', 'Sub Account')}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderValue('COM_ACTIVITY', 'Activity')}
                {renderValue('COM_ACCT_CAT', 'Account Category')}
                {renderValue('RQ_COMMIT_AMT', 'Requisition Commitment Amount', {type: 'currency'})}
                {renderValue('CLOSE_COMMIT_F', 'Close Commitment')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Misc */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Misc</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12}>
                {renderValue('FRST_INVC_DT', 'First Invoice Allowed Date', {type: 'date'})}
                {renderValue('LST_INV_ALW_DT', 'Last Invoice Allowed Date', {type: 'date'})}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Pricing */}
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant='h5'>Pricing</Typography>
            <Grid
              container
              spacing={0}
              direction='row'
              justifyContent='flex-start'
              alignItems='flex-start'
            >
              <Grid item xs={12} sm={6}>
                {renderValue('BASE_PERCENT', 'Base % Markup or Discount')}
                {renderValue('MARKUP_DISC', 'Markup or Discount')}
                {renderValue('AMT_ORDERED', 'Amount Ordered', {type: 'currency'})}
                <Typography variant='subtitle1' style={{ marginTop: '1rem', marginBottom: '0.5rem' }}>Price Break Amounts</Typography>
                {renderValue('BREAK_AMT_1', 'Break Amount 1', {type: 'currency'})}
                {renderValue('BREAK_PCT_1', 'Break Percent 1')}
                {renderValue('BREAK_AMT_2', 'Break Amount 2', {type: 'currency'})}
                {renderValue('BREAK_PCT_2', 'Break Percent 2')}
                {renderValue('BREAK_AMT_3', 'Break Amount 3', {type: 'currency'})}
                {renderValue('BREAK_PCT_3', 'Break Percent 3')}
              </Grid>
              <Grid item xs={12} sm={6}>
                {renderValue('BREAK_AMT_4', 'Break Amount 4', {type: 'currency'})}
                {renderValue('BREAK_PCT_4', 'Break Percent 4')}
                {renderValue('BREAK_AMT_5', 'Break Amount 5', {type: 'currency'})}
                {renderValue('BREAK_PCT_5', 'Break Percent 5')}
              </Grid>
            </Grid>
          </Paper>
        </Grid>

      </Grid>
    </div>
  )
}

